import React, { useContext, useEffect, useState } from 'react';
import Breadcrumb from '../shared/Breadcrumb';
import SideNav from './shared/SideNav';
import ReactStars from "react-rating-stars-component";
import DataTable from 'react-data-table-component';
import Util from '../../Util';
import { apiRoutes } from '../../AppSettings';
import { AuthContext } from '../../contexts/AuthContext';
import axios from 'axios';
import alertify from 'alertifyjs';
import PatientAvatar from './shared/PatientAvatar';

const customStyles = {
    title: {
        style: {
            fontSize: '12px', // override the row height
        }
    },
    rows: {
        style: {
            fontSize: '12px', // override the row height
        }
    },
    headCells: {
      style: {
        paddingLeft: '15px', // override the cell padding for head cells
        paddingRight: '15px',
        fontWeight: 'bold',
        fontSize: '15px'
      },
    },
    cells: {
      style: {
        paddingLeft: '15px', // override the cell padding for data cells
        paddingRight: '15px',
        paddingTop: '10px', // override the cell padding for data cells
        paddingBottom: '8px',
        fontSize: '15px',
      },
    },
};


const Reviews = () => {
    const { userState } = useContext(AuthContext);
    const [data, setData] = useState([]);

    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + userState.token
        }
    };

    useEffect(() => {
        loadGrid();
    }, []);

    const loadGrid = () => {
        axios.get(apiRoutes.GetAllReviews, options)
            .then((response) => {
                if (response.status === 200) {
                    const data = response.data;
                    setData(data);
                }
        }, (error) => {
            console.log(error);
        });
    }

    const handleDelete = (e, id) => {
        alertify.confirm("Warning!", "Are you sure want to delete?",
        function(){
            axios.post(apiRoutes.DeleteReview, JSON.stringify({id: id}), options)
            .then((response) => {
                alertify.success("Review deleted successfully");
                loadGrid();
            }, (error) => {
                console.log(error.response);
            });
        },
        function(){
          
        });
    };

    const columns = [
        {
            name: 'Patient Name',
            selector: 'patientName',
            sortable: true,
            width: '250px',
            cell: row => <PatientAvatar patient = {row.patient} /> 
        },
        {
            name: 'Doctor Name',
            selector: 'firstName',
            sortable: true,
            width: '250px',
            cell: row => <h6 className="table-avatar">
                            <a href="/profile" className="avatar avatar-sm mr-2"><img className="avatar-img rounded-circle" src={Util.loadImage(row.doctor.profileImage)} alt="User Image" /></a>
                            <a href="/profile">Dr {row.doctor.firstName} {row.doctor.lastName}</a>
                        </h6>
        },
        {
            name: 'Rating',
            selector: 'rating',
            sortable: true,
            width: '120px',
            right: true,
            cell: row => <div><ReactStars value={row.rating} edit={false} size={20} /></div> 
        },

        {
            name: 'Description',
            selector: 'review',
            sortable: true,
            width: '200px'
        },
        {
            name: 'Date',
            selector: 'createdDate',
            sortable: true,
            width: '190px',
            cell: row => <div>{
                            new Intl.DateTimeFormat("en-GB", {
                            year: "numeric",
                            month: "short",
                            day: "2-digit"
                            }).format(new Date(row.createdDate+".000Z"))
                        }<br/><small>{Util.getTimeAMPM((new Date(row.createdDate)))}</small></div>
        },
        {
            name: 'Actions',
            selector: 'CreatedDate',
            sortable: true,
            width: '180px',
            cell: row => <div class="actions">
                            <a class="btn btn-sm bg-danger-light" data-toggle="modal" href="#delete_modal"  onClick={e => handleDelete(e, row.reviewId)}>
                                <i class="fe fe-trash"></i> Delete
                            </a>
                        </div>
        }
    ];

    return (  
        <div>
            <Breadcrumb title="Reviews"></Breadcrumb>
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <SideNav applyCssFor='reviews' />
                        </div>
                        <div className="col-md-7 col-lg-8 col-xl-9">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <DataTable
                                                title="Reviews"
                                                columns={columns}
                                                data={data}
                                                customStyles={customStyles}
                                                pagination
                                                highlightOnHover={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default Reviews;